var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscountMedication = function SvgDiscountMedication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "#fff",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M46.5 36.5a9.9 9.9 0 0 0-5 1.353V30.25a8.75 8.75 0 0 0-17.5 0v17.5a8.749 8.749 0 0 0 15.357 5.735A9.995 9.995 0 1 0 46.5 36.5m0 2.5a7.506 7.506 0 0 1 7.388 6.25H39.112A7.506 7.506 0 0 1 46.5 39m-20-8.75a6.25 6.25 0 0 1 12.5 0v7.5H26.5zM32.75 54a6.26 6.26 0 0 1-6.25-6.25v-7.5h12.206a9.95 9.95 0 0 0-.905 11.164A6.24 6.24 0 0 1 32.75 54m13.75 0a7.506 7.506 0 0 1-7.388-6.25h14.776A7.506 7.506 0 0 1 46.5 54"
  })));
};
export default SvgDiscountMedication;